import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'
import store from '@/store'
const token = '2B4C7E4A-1B17-4B51-9D09-051FE1D75239'

export default {
  setTestMode({ commit }, mode) {
    commit(types.SET_TESTMODE, mode)
  },
  setOnboard({ commit }, data) {
    commit(types.SET_ONBOARD, data)
  },
  resetPaymentMethod({ commit }) {
    commit(types.RESET_PAYMENTMETHOD)
  },
  toggleDisable({ commit }, value) {
    commit(types.SET_DISABLE, value)
  },
  prepOnboard({ commit }, data) {
    commit(types.PREP_ONBOARD, data)
  },
  async getOnboard({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getOnboard', () => http.get(`firm/onboardGet?firm=${firm}`))
    commit(types.SET_FIRM_ONBOARD, r.data)
    return r.data
  },
  async changeProduct({ commit, dispatch }, product) {
    const r = await startLoading(dispatch, 'changeProduct', () => http.post('firm/onboardChangeProduct', product))
    return r.data
  },
  async save({ commit, dispatch, state }, action) {
    let result = null
    let endpoint = null
    let firm = null
    switch (action) {
      case 'basic':
        console.log('Saving Basic', state.onboard.basic)
        endpoint = 'firm/onboardMarketing'
        if (!state.testMode) {
          result = await startLoading(dispatch, 'save', () =>
            http.post(endpoint, {
              marketing: state.onboard.basic.marketing,
              firstName: state.onboard.basic.firstname,
              lastName: state.onboard.basic.lastname,
              emailAddress: state.onboard.basic.email,
              token: token
            })
          )
        } else {
          result = {
            data: 0
          }
        }
        commit(types.SET_BASICID, result.data)
        break
      case 'additional':
        console.log('Saving Additional', state.onboard.additional)
        if (state.onboard.additional.firm !== null) {
          endpoint = 'firm/onboardFirmUpdate'
        } else {
          endpoint = 'firm/onboardFirm'
        }
        if (!state.testMode) {
          result = await startLoading(dispatch, 'save', () =>
            http.post(endpoint, {
              firm: state.onboard.additional.firm,
              company: state.onboard.additional.company,
              firstName: state.onboard.basic.firstname,
              lastName: state.onboard.basic.lastname,
              jobTitle: null,
              email: state.onboard.basic.email,
              addressLines: state.onboard.additional.addresslines,
              city: state.onboard.additional.city,
              stateProvince: state.onboard.additional.stateprovince,
              postalCode: state.onboard.additional.postalcode,
              country: state.onboard.additional.country,
              phoneCC: state.onboard.additional.phonecc,
              phoneNo: state.onboard.additional.phoneno,
              languageId: state.onboard.additional.language,
              timezoneId: state.onboard.additional.timezone,
              webaddress: state.onboard.additional.webaddress,
              companyId: state.onboard.additional.companyId,
              firmType: 'Corporate',
              token: token
            })
          )
        } else {
          result = {
            data: 0
          }
        }
        firm = result.data
        commit(types.SET_FIRMID, result.data)
        break
      case 'shipping':
        console.log('Saving Shipping', state.onboard.shipping)
        endpoint = 'firm/onboardShippingSave'
        if (!state.testMode) {
          result = await startLoading(dispatch, 'save', () =>
            http.post(endpoint, {
              id: state.onboard.shipping.id,
              firm: state.onboard.shipping.firm,
              addressLines: state.onboard.shipping.addresslines,
              city: state.onboard.shipping.city,
              stateProvince: state.onboard.shipping.stateprovince,
              postalCode: state.onboard.shipping.postalcode,
              country: state.onboard.shipping.country,
              token: token
            })
          )
        } else {
          result = {
            data: 0
          }
        }
        firm = state.onboard.additional.firm
        commit(types.SET_SHIPID, result.data)
        break
      case 'purchase':
        console.log('Saving Purchase', state.onboard.purchase)
        let country = await store.dispatch('lookups/getCountryCode', state.onboard.additional.country)
        let stateprovince = await store.dispatch('lookups/getStateProvinceAbbr', state.onboard.additional.stateprovince)
        // Update Purchase Info
        endpoint = 'firm/onboardPurchaseSave'
        result = await startLoading(dispatch, 'save', () =>
          http.post(endpoint, {
            firm: state.onboard.purchase.firm,
            product: state.onboard.purchase.product,
            paymentMethod: {
              id: state.onboard.purchase.paymentMethod.id,
              brand: state.onboard.purchase.paymentMethod.card.brand,
              last4: state.onboard.purchase.paymentMethod.card.last4
            },
            company: state.onboard.additional.company,
            name: `${state.onboard.basic.firstname} ${state.onboard.basic.lastname}`,
            email: state.onboard.basic.email,
            address: {
              addresslines: state.onboard.additional.addresslines,
              city: state.onboard.additional.city,
              stateprovince: stateprovince,
              postalcode: state.onboard.additional.postalcode,
              country: country
            },
            phone: `${state.onboard.additional.phonecc}-${state.onboard.additional.phoneno}`,
            coupon: state.onboard.purchase.coupon,
            token: token,
            testMode: state.testMode
          })
        )
        firm = state.onboard.additional.firm
        break
    }
    if (result !== null) {
      return { firm: firm, id: result.data }
    } else {
      return { firm: firm, id: null }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/onboard/actions.js